import {
  SET_DICTINJURYTYPE,
  SET_DICTINJURYTYPES,
  SET_DICTINJURYTYPES_SET_IS_FETCHING,
  SET_DICTINJURYTYPES_QUERY_PARAMS,
} from '../constants/injuryTypesActionsTypes';

const initialState = {
  list: [],
  params: {
    page: 1,
    perPage: 10,
    sort: 'created_at,desc',
    search: '',
  },
  dictInjuryType: {},
  isFetching: false,
  total: 0,
};

function dictInjuryTypes(state = initialState, action) {
  switch (action.type) {
    case SET_DICTINJURYTYPE:
      return {
        ...state,
        dictInjuryType: action.data,
      };
    case SET_DICTINJURYTYPES:
      return {
        ...state,
        list: action.data.dictInjuryTypes,
        total: action.data.total,
      };
    case SET_DICTINJURYTYPES_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    case SET_DICTINJURYTYPES_SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    default:
      return state;
  }
}

export default dictInjuryTypes;
